<template>
  <div class="container">
<!-- 	  <Header lineIsShow="1"></Header> -->
   <div class="top" style="display: flex;justify-content: space-between;">
      <div style="width:100%;max-width:1200px;margin:0px auto;">
        <div style="margin-top: 18px;color: white;margin-right: 20px;position: absolute;right: 0px;font-size: 15px;">
          <router-link :to="{name:'Complain_info'}" style="color: white;">投诉建议</router-link>
        </div>
        <div class="logo">
          <router-link to='/'><img src="../assets/logo.png"></router-link>
        </div>
        <ul class="pc pcnav">
          <li>
            <router-link :to="{name:'Common_product'}">产品介绍</router-link>
          </li>
          <li class="currents">
            <router-link :to="{name:'Common_introduce'}">公司介绍</router-link>
          </li>
          <li>
            <router-link :to="{name:'Common_video'}">实时监控</router-link>
          </li>
          <li>
            <!-- <router-link :to="{name:'Common_drew'}">码上有礼</router-link> -->
          </li>
        </ul>
        <div class="qh" style="margin-top: 18px;color: white;margin-right: 20px;">
          <a href="javascript:void(0)" @click="getIntegral" class="integral-btn"><img style="width:20px;vertical-align: text-bottom;" src="../assets/icon-jifen.png"/>积分获取</a>
        </div>
      </div>
    </div>
   <ul class="nav">
      <li style="position: relative">
        <router-link :to="{name:'Common_product'}">产品介绍</router-link>
      </li>
      <li class="current">
        <router-link :to="{name:'Common_introduce'}">企业介绍</router-link>
        <p class="ui-line"></p>
      </li>
      <li style="position: relative">
        <router-link :to="{name:'Common_video'}">实时监控</router-link>
      </li>
      <li style="position: relative">
        <!-- <router-link :to="{name:'Common_drew'}">码上有礼</router-link> -->
      </li>
    </ul>
    <div v-if="data.mainUrl" style="pointer-events: none;">
      <cube-slide ref="slide" :showDots="false" :loop="false" :auto-play="false" style="width: 100%">
        <cube-slide-item style="width: 100% ">
          <!-- <a class="banner"> -->
          <img style="width: 100%; pointer-events: none;" :src="data.mainUrl" />
          <!-- </a> -->
        </cube-slide-item>
      </cube-slide>
    </div>
    <div :class=" { isNoImg: data.mainUrl == ' ' } " class="introduce">
      <p style="margin-top: 0.5rem">
        <span>公司名称</span>:
        <span>{{data.orgName}}</span>
      </p>
      <p style="margin: 0.6rem 0">
        <span>公司地址</span>:
        <span>{{data.address}}</span>
      </p>
      <p>
        <span>咨询电话</span>:
        <span>{{data.managerPhone}}</span>
      </p>
      <p v-if="data.logoUrl">
        <span>公司logo</span>:
        <span>
          <img class="gs-logo" :src="data.logoUrl" />
        </span>
      </p>
    </div>
    <div class="pc pcintroduce pcheight">
      <h2>公司简介</h2>
      <div class="jb" style="min-height: 160px; padding: 20px 0;">
        <p>
          <span style="color: #333;font-weight: bold">公司名称</span>
          ：{{data.orgName}}
        </p>
        <p>
          <span style="color: #333;font-weight: bold">公司地址</span>
          ：{{data.address}}
        </p>
        <p>
          <span style="color: #333;font-weight: bold">咨询电话</span>
          ：{{data.managerPhone}}
        </p>
      </div>
      <div class="nr">{{data.corpEName}}</div>
    </div>
    <div v-if="newsList<0" class="store mb newsLists">
      <h3 style="font-weight: bold">公司资讯</h3>
      <div style="padding-top: 6px;">
        <div>
          <a
            v-for="item in newsList"
            @click="routerTo(item.id)"
            class="newsList"
            href="javascript:void(0);"
            style="display:flex;
            justify-content: space-between;color: #333;
            font-size: 14px; padding: 6px 10px;"
          >
            <span class="newsTitle" :title="item.title">{{item.title}}</span>
            <span>{{item.createTime}}</span>
          </a>
        </div>
      </div>
    </div>
    <div v-if="newsList<0" class="pc pcintroduce pcheight">
      <h2>公司资讯</h2>
      <div class>
        <a
          v-for="item in newsList"
          @click="routerTo(item.id)"
          class="newsList"
          href="javascript:void(0);"
          style="display:flex;
              justify-content: space-between;color: #333;
              font-size: 14px; padding: 6px 10px;"
        >
          <span class="newsTitle" :title="item.title">{{item.title}}</span>
          <span>{{item.createTime}}</span>
        </a>
      </div>
    </div>
    <!-- 如果data.length为0的话,证明一个链接都没有,那么这个模块都不用显示 -->
    <div v-if="data.hnUrl || data.jdUrl || data.tmallUrl" class="store mb newsLists">
      <h3 style="font-weight: bold">公司网店</h3>
      <!-- 公司网店区域展示的惠农,淘宝或者京东的链接, -->
      <div class="shopList">
        <div v-if="data.hnUrl" class="shop">
          <a target="_blank" :href="data.hnUrl">
            <img src="../assets/hn.png" alt />
          </a>
          <!-- <span>惠农地址:</span> -->
        </div>
        <div v-if="data.tmallUrl" class="shop">
          <a target="_blank" :href="data.tmallUrl">
            <img src="../assets/tb.png" alt />
          </a>
          <!-- <span>淘宝地址:</span> -->
        </div>
        <div v-if="data.jdUrl" class="shop">
          <a target="_blank" :href="data.jdUrl">
            <img src="../assets/jd.png" alt />
          </a>
          <!-- <span>京东地址:</span> -->
        </div>
      </div>
    </div>
    <div class="pc pcintroduce pcheight" v-if="data.hnUrl||data.tmallUrl||data.jdUrl">
      <h2>公司网店</h2>
      <div class="shopList">
        <div class="shop" v-if="data.hnUrl">
          <a target="_blank" :href="data.hnUrl">
            <img src="../assets/hn.png" alt />
          </a>
        </div>
        <div class="shop" v-if="data.tmallUrl">
          <a target="_blank" :href="data.tmallUrl">
            <img src="../assets/tb.png" alt />
          </a>
        </div>
        <div class="shop" v-if="data.jdUrl">
          <a target="_blank" :href="data.jdUrl">
            <img src="../assets/jd.png" alt />
          </a>
        </div>
      </div>
    </div>
    <div class="store mb">
      <h3 style="font-weight: bold">公司简介</h3>
      <div style="min-height:100px;width: 100%;">
        <p
          style="font-size:0.6rem;width: 100%;line-height: 1rem;margin-top: 0.5rem;text-indent: 20px;text-align: left;padding:0 10px;"
        >{{data.corpEName}}</p>
      </div>
    </div>
    <div class="store">
      <h3 style="font-weight: bold">公司营业执照</h3>
      <div style="min-height:100px;width: 100%;">
        <p
          style="font-size:14px;width: 100%;line-height: 1rem;margin-top: 0.5rem;text-align: left;padding:0 10px"
        >
          <img style="width:100%" :src="data.hdnImgUrl" />
        </p>
      </div>
    </div>
    <cp-footer></cp-footer>
  </div>
</template>

<script>
import cpFooter from "@/views/footer";
import { getNewsList } from "@/api/api";
import { formatTime } from "@/utils/common";
export default {
  name: "Common_introduce",
  components: {
    cpFooter
    // Header
  },
  data() {
    return {
      num: "",
      menu_show: false,
      menu_show1: false,
      selectedLabelDefault: "首页",
      data: {},
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      items: [
        {
          url: "",
          image: ""
        }
      ],
      newsList: [],
      orgId: ""
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Common_introduce/gi.test(to.path)) {
        this.num = localStorage.getItem("zymCode");
        this.getList();
        this.getNewsLists();
      }
    }
  },
  created() {
    this.num = localStorage.getItem("zymCode");
    this.getList();
    this.getNewsLists();
    this.integralData();
  },
  watch: {
    '$route':'integralData'
  },
  methods: {
    // 网店
    shopTo() {},
    // 企业资讯
    routerTo(id) {
      this.$router.push({
        name: `newsDetails`,
        query: {
          id: id
        }
      });
    },
    getNewsLists() {
      let parmas = {
        areaId: localStorage.getItem("orgId"),
        size: 4
      };
      // console.log('parmas', parmas)
      getNewsList(parmas).then(res => {
        // console.log('res', res.data)
        if (res.status == 200) {
          for (let i = 0; i < res.data.data.records.length; i++) {
            this.newsList.push({
              id: res.data.data.records[i].id,
              title: res.data.data.records[i].title,
              areaId: res.data.data.records[i].areaId,
              createUser: res.data.data.records[i].createUser,
              createTime: formatTime(
                Date.parse(res.data.data.records[i].createTime),
                "YYYY/MM/DD"
              )
            });
            // console.log("newList", this.newsList);
          }
        }
      });
    },
    getList() {
      this.$axios({
        method: "get",
        url: "portal/suyuan/getCompanyInfo/" + this.num
      })
        .then(res => {
          this.data = res.data.data;
          // console.log('企业介绍', this.data)
        })
        .catch(err => {});
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    showmenu() {
      if (this.menu_show == true) {
        this.menu_show = false;
      } else if (this.menu_show == false) {
        this.menu_show = true;
      }
    },
    showmenu1() {
      if (this.menu_show1 == true) {
        this.menu_show1 = false;
      } else if (this.menu_show1 == false) {
        this.menu_show1 = true;
      }
    },
    getIntegral() {
      var _this = this;
      var wx_code = _this.$route.query.code;
      var wx_state = _this.$route.query.state;
      if(!wx_code && !wx_state){
        _this.$axios({
          method: "get",
          url: "portal/integral/verify/count/" + _this.num
        })
          .then(res => {
            if(res.data.code == 0){
              if(res.data.data <= 0){
                var appid = "wxfe3edde0e854125b";
                var scope = "snsapi_userinfo";
                var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope='+scope+'&state='+_this.num+'#wechat_redirect';
                window.location.replace(auth_url);
              }else{
                _this.$Message.error("此积分已被获取!");
              }
            }else{
              _this.$Message.error(res.data.msg);
            }
          })
          .catch(err => {
            alert(err);
            console.log(err);
          });
      }else{
        _this.$Message.error("您已获取积分!");
      }
    },
    integralData(){
      var _this = this;
      var wx_code = _this.$route.query.code;
      var wx_state = _this.$route.query.state;
      if(wx_code && wx_state){
        _this.$axios({
          method: "get",
          url: "portal/integral/verify/count/" + _this.num
        })
          .then(res => {
            if(res.data.code == 0){
              if(res.data.data <= 0){
                _this.$axios({
                  method: "post",
                  url: "portal/integral/add/integral/" + _this.num + "?code="+wx_code,
                  headers: {
                    "Content-Type": "application/json"
                  }
                })
                  .then(res => {
                    if(res.data.code == 0){
                      _this.$Message.success(res.data.msg);
                    }else{
                      _this.$Message.error(res.data.msg);
                    }
                  })
                  .catch(err => {
                    alert(err);
                    console.log(err);
                  });
              }
            }else{
              _this.$Message.error(res.data.msg);
            }
          })
          .catch(err => {
            alert(err);
            console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-color: #f5f5f5;
}
.top {
  height: 3rem;
  background-color: #45b035;
}
.logo {
  width: 25%;
  margin:0px auto;
  line-height: 3rem;
}
.logo > a{
  display: inline-block;
  margin-top:10%;
}
.logo img {
  display: block;
  width: 100%;
}
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.nav {
  list-style: none;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1ebeb;
  background-color: white;
}
.nav a {
  color: #333333;
  margin: 12px 0;
  display: inline-block;
}
.nav .ui-line{
  width: 1.12rem;
  height: 0.1rem;
   background-color: #39BF3E;
   margin: 0px auto;
  }
.nav li {
  width: 33%;
}
.nav li:hover {
  color: #45b035;
}
.current a {
  color: #45b035;
}
.banner img {
  width: 100%;
}
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #333;
  padding: 0rem 1rem;
  background-color: white;
  margin: 23px 20px 0px 20px;
  padding: 0.8rem;
  border-radius: 15px;
  z-index: 1;
  position: relative;
  top: -12px;
}
.isNoImg {
  top: 0;
  margin: 0;
  border-radius: 0;
  margin-bottom: 0;
  top: -10px;
}

.introduce p {
  margin-bottom: 0.4rem;
}
.store {
  background-color: white;
  padding: 0.8rem;
}
h3 {
  font-size: 0.9rem;
  text-align: left;
  position: relative;
  padding-left: 20px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
}
h3:before {
  position: absolute;
  content: "";
  left: 10px;
  top: 0;
  width: 3px;
  height: 16px;
  background-color: #45b035;
}
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.img_content img {
  border-radius: 6px;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}

.pc {
  display: none;
}
.qh{
	  display: none;
  }
/* @media screen and (min-width: 1000px) {
  .container {
    background-color: #fff !important;
  }
  .jb p {
    width: 100%;
    margin-top: 10px;
  }
  .top {
    background: #45b035;
    height: 2rem;
  }

  .logo {
    width: 160px;
    margin-left: 20px;
    line-height: 3rem;
    float: left;
  }
  .logo > a{
    margin-top: 10px;
  }
  .img {
    width: 40%;
    margin: 0 auto;
  }
  .img img {
    width: 80%;
  }
  .ct {
    width: 88%;
    display: flex;
    margin: 8% auto;
    justify-content: space-around;
  }
  .rt {
    width: 60%;
  }
  .name {
    font-size: 1rem;
  }
  .wz {
    margin-top: 0.7rem !important;
  }
  .it {
    margin-top: 0.8rem !important;
  }
  .qh {
    display: block;
    float: right;
  }
  .pc {
    display: block;
  }
  .pcnav {
    width: 400px;
    display: flex;
    font-size: 18px;
    color: white;
    line-height: 2rem;
    justify-content: space-between;
    float: left;
    margin-left: 100px;
  }
  .pcnav a {
    color: white;
  }
  .nav {
    display: none;
  }
  .introduce {
    display: none;
  }
  .store {
    display: none;
  }
  .pcintroduce {
    margin: 0 auto;
    overflow: hidden;
    overflow-x: auto;
    width: 1200px;
  }
  .pcheight {
    padding-top: 100px;
  }
  .pcintroduce h2 {
    text-align: center;
    color: #333;
    padding-bottom: 26px;
    font-size: 32px;
    color: #333;
    background: url(../assets/line_01.png) no-repeat center bottom;
  }
  .bg {
    display: none;
  }
  .nr {
    width: 1200px;
    margin: 20px auto;
    text-align: left;
    line-height: 24px;
    font-size: 14px;
  }
  .jb {
    font-size: 16px;
    text-align: left;
    width: 1200px;
    margin: 10px auto;
  }
  .top {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    display: block;
  }
  .pcnav .currents {
    position: relative;
  }
  .pcnav .currents:after {
    position: absolute;
    content: "";
    left: 0;
    bottom: 15px;
    height: 3px;
    width: 100%;
    background-color: #fff;
  }
  .qh{
  	  display: block;
    }
} */
</style>
<style lang="scss" scoped>
@import "@/assets/css/rem.scss";
.container {
  background-color: #f5f5f5;
}
.container .mb {
  margin-bottom: rem(20);
}
.gs-logo {
  width: rem(60);
  height: rem(60);
}
.newsTitle {
  text-align: left;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shopList {
  font-size: 14px;
  padding: 12px 10px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .shop {
    width: 30%;
    // margin-right: 3%;
    text-align: center;
    &:last-of-type {
      margin-right: 0;
    }
    > a {
      display: block;
      text-align: center;
      // margin-bottom: 6px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .pcintroduce {
    .shopList {
      padding-top: 40px;
    }
  }
}
.cube-slide .cube-slide-group .cube-slide-item{
  pointer-events: none;
}

  .integral-btn-wrapper {
    width: 400px;
    padding: 50px;
    background-color: yellow;
  }

  .integral-btn {
    color: white;
    background: #DFAB04;
    height: 58px;
    border: 2px solid #C1AC0E;
    font: 500 20px "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0 10px;
    transition: color 0.1s linear, background-color 0.1s linear, border-color 0.1s linear;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .integral-btn:hover {
    background: #C1AC0E;
    border-color: #C1AC0E;
  }

  .integral-btn:active {
    background: #45B035;
    border-color: #C1AC0E;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common_introduce.vue